




































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import GeneralService from "@/services/general-service";
import config from "@/services/api-config";
import * as moment from "moment";

@Component({
  props: [
    "lifetime",
    "cost",
    "savings",
    "inverters",
    "sorted_inverters",
    "deviceId",
  ],
})
export default class rightSidebar extends Vue {
  private lifetime: Number;
  private cost: Number;
  private savings: Number;
  private inverters: any;
  private deviceId: any;
  private sorted_inverters: any;
  private filterby = "power";
  private deratingValue = -1;
  private invertersAlarms: any[] = [];
  private options = [
    { text: "Power Now", value: "power" },
    { text: "Lifetime Energy", value: "lifetime" },
  ];

  private userRoles = JSON.parse(localStorage[config.userRole]);
  private inverter_list: any = Array.from(this.sorted_inverters);
  private selectedInverter = 0;
  private liveStatus: any = "";
  private mpptValues: any = [];
  private alarmValues: any = [];
  private isLoading = false;
  private error = "";

  private service = new GeneralService();
  private fieldsInverter = [
    {
      key: "power",
      label: "Power Generated",
    },
    {
      key: "inner_temp",
      label: "Inner Temperature",
    },
    {
      key: "lifetime_energy",
    },
    {
      key: "max_power",
    },
  ];
  lastUpdated: any = "";
  inverterSelected(items, index) {
    // this.invertersAlarms = items.alarms;
    this.deratingValue = -1;
    if (items)
      this.lastUpdated = items.lastUpdated;
    // alert(JSON.stringify(items));
    this.selectedInverter = index;
    (this.$refs["inverter-modal"] as any).show();
    this.liveStatus = "";
    this.error = "";
    this.mpptValues = [];
    if (this.userRoles.includes("admin") || this.userRoles.includes("tech"))
      this.doAction(3);
  }

  showAlarms(item) {
    this.invertersAlarms = item.alarms;
    // alert(JSON.stringify(this.invertersAlarms));
    this.$bvModal.show("inverterAlarms");
  }
  formatDate(value) {
    if (value && value !== '')
      return moment.unix(value).format("DD-MM-YYYY, hh:mm a");
    else {
      return '';
    }
  }
  doAction(action) {
    this.isLoading = true;
    this.error = "";
    // alert(JSON.stringify(this.inverter_list));
    if ((this.deratingValue < 1 || this.deratingValue > 100) && action == 5 ){
      alert("Derating Value should be 1-100");
      this.isLoading = false;
      return;
    }
    this.service
      .getInvertorData(
        this.deviceId,
        this.inverter_list[this.selectedInverter].inverter_id,
        action,
        this.deratingValue
      )
      .then((response) => {
        this.isLoading = false;
        if (response.meta.success && response.data.action == 3) {
          this.liveStatus = response.data.inverter_status;
        }

        if (response.meta.success && response.data.action == 4) {
          this.mpptValues = response.data.string_values;
        }

        if (response.meta.success && response.data.action == 5) {
          console.log(response)
        }

        if (response.meta.success && response.data.action == 6) {
          this.alarmValues = response.data.string_values;
        }

        if (
          response.meta.success &&
          (response.data.action == 1 || response.data.action == 2)
        ) {
          this.liveStatus = "";
          this.error = "Fetching Live Status";
          setTimeout(() => {
            this.doAction(3);
            this.error = "";
          }, 8000);
        }

        if (!response.meta.success) {
          this.error = response.meta.message;
        }
      }).catch((err) => {
        this.isLoading = false;
      });
  }

  filterChange() {
    if (this.filterby == "power") {
      this.inverter_list = Array.from(this.inverters);
    } else {
      this.inverter_list = Array.from(this.sorted_inverters);
    }
  }

  formatNumber(num, suffix) {
    if (num) {
      if (num.toString().length > 6 && suffix == "PKR") {
        return (
          num
            .toString()
            .substring(0, num.toString().length - 6)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
          "." +
          num.toString()[num.toString().length - 6] +
          num.toString()[num.toString().length - 5] +
          "M" +
          " " +
          suffix
        );
      } else if (num.toString().length > 6 && suffix == "kWh") {
        return (
          num
            .toString()
            .substring(0, num.toString().length - 6)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
          "." +
          num.toString()[num.toString().length - 6] +
          num.toString()[num.toString().length - 5] +
          " " +
          "GWh"
        );
      } else if (num.toString().length > 3 && suffix == "PKR") {
        return (
          num
            .toString()
            .substring(0, num.toString().length - 3)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
          "K" +
          " " +
          suffix
        );
      } else if (num.toString().length > 3 && suffix == "kWh") {
        return (
          num
            .toString()
            .substring(0, num.toString().length - 3)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
          "." +
          num.toString()[num.toString().length - 3] +
          " " +
          "MWh"
        );
      }

      return (
        num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + " " + suffix
      );
    }

    return 0;
  }
}
